import React from "react";
import { Link } from "react-router-dom";
import { LogIn, Search } from "lucide-react";

// Página pública (sem autenticação): header no mesmo padrão do app (logo à
// esquerda) e botão de Login à direita.
export default function PublicHome() {
  return (
    <div className="flex min-h-screen flex-col bg-background text-foreground">
      {/* Header — mesmo padrão do app */}
      <header className="flex items-center justify-between border-b border-border bg-card z-50">
        <div className="flex w-52 items-center justify-center border-r border-border px-4 py-3">
          <img
            src="/assets/stratasec_light.png"
            alt="SecurityScan"
            className="h-7 w-auto drop-shadow-[0_0_10px_rgba(255,255,255,0.4)]"
          />
        </div>
        <div className="px-6 py-3">
          <Link
            to="/login"
            className="inline-flex items-center gap-2 rounded-lg bg-primary px-4 py-2 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90"
          >
            <LogIn size={16} />
            Login
          </Link>
        </div>
      </header>

      {/* Corpo — hero */}
      <main className="flex flex-1 items-center justify-center px-4">
        <div className="max-w-2xl text-center">
          <img
            src="/assets/stratasec_light.png"
            alt="SecurityScan"
            className="mx-auto mb-8 h-12 w-auto drop-shadow-[0_0_16px_rgba(255,255,255,0.35)]"
          />
          <h1 className="text-3xl font-bold tracking-tight sm:text-4xl">SecurityScan</h1>
          <p className="mt-4 text-base text-muted-foreground">
            Mapeamento da superfície de ataque da Internet — IPs, portas, serviços,
            banners, registros DNS e certificados TLS.
          </p>
          <div className="mt-8 flex items-center justify-center gap-3">
            <Link
              to="/login"
              className="inline-flex items-center gap-2 rounded-lg bg-primary px-5 py-2.5 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90"
            >
              <Search size={16} />
              Acessar a busca
            </Link>
          </div>
        </div>
      </main>

      <footer className="border-t border-border px-6 py-4 text-center text-xs text-muted-foreground">
        &copy; Sec4US 2026 · SecurityScan
      </footer>
    </div>
  );
}
